import { useState } from "react";
import { useInView } from "../hooks/useInView";
import { experiences, certificates } from "../data/content";
import Lightbox from "./Lightbox";
import styles from "./Experience.module.css";

function ExpCard({ exp, delay = 0 }) {
  const [ref, inView] = useInView();

  return (
    <div
      ref={ref}
      className={`${styles.card} ${inView ? styles.visible : ""}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <h3>{exp.title}</h3>
      <p className={styles.period}>{exp.period}</p>
      <p>{exp.description}</p>
    </div>
  );
}

export default function Experience() {
  const [titleRef, titleInView] = useInView();
  const [activeCertificate, setActiveCertificate] = useState(null);

  return (
    <>
      <section className={styles.experience} id="experience">
        <h2
          ref={titleRef}
          className={`${styles.title} ${titleInView ? styles.visible : ""}`}
        >
          EXPERIÊNCIA
        </h2>

        <div className={styles.grid}>
          {experiences.map((exp, index) => (
            <ExpCard key={exp.id} exp={exp} delay={index * 100} />
          ))}
          </div>
        {certificates.length > 0 && (
          <div className={styles.certs}>
            <h3 className={styles.certsTitle}>CERTIFICADOS</h3>
            <div className={styles.certGrid}>
              {certificates.map((cert) => (
                <button
                  key={cert.id}
                  type="button"
                  className={styles.certButton}
                  onClick={() => setActiveCertificate(cert)}
                  aria-label={`Ampliar ${cert.title}`}
                >
                  <img
                    src={cert.image}
                    alt={cert.title}
                    className={styles.certImg}
                  />
                  <span className={styles.zoom}>↗</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </section>

      {activeCertificate && (
        <Lightbox
          src={activeCertificate.image}
          alt={activeCertificate.title}
          onClose={() => setActiveCertificate(null)}
        />
      )}
    </>
  );
}
